/**
 * @fileoverview GET handler for the "/engagement/recommendations_metadata" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementRecommendationsMetadata } from "./constants";
import type { EngagementRecommendationsMetadataResult } from "./types";

export const getEngagementRecommendationsMetadata = reactQueryFetcherAdapter(
  engagementRecommendationsMetadata,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementRecommendationsMetadataResult> => {
    return fetch("/engagement/recommendations_metadata", "GET", { app_group_id: appGroupId }, { signal });
  }
);
